import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startImportButton"]
  static outlets = ["credit-indicator", "leads-imports--limit-reached"]

  connect() {
    if (this.hasCreditIndicatorOutlet) {
      this.checkCreditStatus()
    } else if (this.hasLeadsImportsLimitReachedOutlet) {
      this.checkLimitStatus()
    }
  }

  creditIndicatorOutletConnected() {
    this.checkCreditStatus()

    this.observeCreditChanges()
  }

  leadsImportsLimitReachedOutletConnected() {
    this.checkLimitStatus()

    this.observeLimitChanges()
  }

  checkCreditStatus() {
    if (!this.hasCreditIndicatorOutlet) return

    const missingCredits = this.creditIndicatorOutlet.missingCreditsValue || 0
    this.updateButtonBehavior(missingCredits > 0)
  }

  checkLimitStatus() {
    if (!this.hasLeadsImportsLimitReachedOutlet) return

    const searchLimit = this.leadsImportsLimitReachedOutlet.searchLimitValue || false
    const verifyLimit = this.leadsImportsLimitReachedOutlet.verifyLimitValue || false
    this.updateButtonBehavior(searchLimit || verifyLimit)
  }

  observeCreditChanges() {
    if (!this.hasCreditIndicatorOutlet) return

    const observer = new MutationObserver(() => {
      this.checkCreditStatus()
    })

    observer.observe(this.creditIndicatorOutlet.element, {
      attributes: true,
      attributeFilter: ['data-credit-indicator-missing-credits-value'],
      subtree: true,
      childList: true
    })

    this.creditObserver = observer
  }

  observeLimitChanges() {
    if (!this.hasLeadsImportsLimitReachedOutlet) return

    const observer = new MutationObserver(() => {
      this.checkLimitStatus()
    })

    observer.observe(this.leadsImportsLimitReachedOutlet.element, {
      attributes: true,
      attributeFilter: ['data-leads-imports--limit-reached-search-limit-value', 'data-leads-imports--limit-reached-verify-limit-value'],
      subtree: true,
      childList: true
    })

    this.limitObserver = observer
  }

  updateButtonBehavior(hasInsufficientCredits) {
    if (!this.hasStartImportButtonTarget) return

    if (hasInsufficientCredits) {
      // Show modal when insufficient credits
      this.startImportButtonTarget.type = "button"
      this.startImportButtonTarget.removeAttribute("form")
      this.startImportButtonTarget.setAttribute("data-bs-toggle", "modal")
      this.startImportButtonTarget.setAttribute("data-bs-target", "#creditsOptionsModal")
    } else {
      // Submit form when sufficient credits
      this.startImportButtonTarget.type = "submit"
      this.startImportButtonTarget.setAttribute("form", "leads-import-form")
      this.startImportButtonTarget.removeAttribute("data-bs-toggle")
      this.startImportButtonTarget.removeAttribute("data-bs-target")
    }
  }

  creditsUpdated(missingCredits) {
    this.updateButtonBehavior(missingCredits > 0)
  }

  disconnect() {
    if (this.creditObserver) {
      this.creditObserver.disconnect()
    }
    if (this.limitObserver) {
      this.limitObserver.disconnect()
    }
  }
}
